import { utils } from '@febos-io/common';

export const getPrices = (companyId, referenceId, level, page, limit = 1, filter = undefined) => ({
  path: `v1/companies/${companyId}/documents/settings/prices`,
  params: {
    referenceId,
    level,
    page,
    limit,
    ...{ ...filter && ({ filter }) }
  }
});

export const savePrice = (
  companyId,
  examId,
  {
    level,
    referenceId,
    value,
    type
  }
) => ({
  path: `v1/companies/${companyId}/documents/settings/prices/${examId}`,
  method: utils.METHOD.POST,
  content: {
    level,
    referenceId,
    value,
    type
  }
});

export const savePrices = (
  companyId,
  prices
) => ({
  path: `v1/companies/${companyId}/documents/settings/prices/`,
  method: utils.METHOD.POST,
  content: {
    prices
  }
});
